import { render, staticRenderFns } from "./dashboardTeamsEvent.vue?vue&type=template&id=beb9dad6&scoped=true&"
import script from "./dashboardTeamsEvent.vue?vue&type=script&lang=js&"
export * from "./dashboardTeamsEvent.vue?vue&type=script&lang=js&"
import style0 from "./dashboardTeamsEvent.vue?vue&type=style&index=0&id=beb9dad6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb9dad6",
  null
  
)

export default component.exports